function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import cn from 'classnames';
import { Typography } from 'seagull';
import { AgreementViewCard, Logo, TopStripe } from "./CommonComponents";
import styles from "./SignedHeader.module.scss";
import { relationshipModel, timeModel } from "../../../../models";
import { getSortedFormattedDigitalSignatures } from "../AgreementView.utils";
import compact from 'lodash/compact';
import DigitalSignature from "../../../DigitalSignature/DigitalSignature";
const DetailsText = props => /*#__PURE__*/React.createElement(Typography, _extends({
  ellipsis: true,
  skin: "secondary"
}, props));
export default function SignedHeader(_ref) {
  let {
    relationship,
    brandColor,
    testPrefix
  } = _ref;
  const vendorLogoUrl = relationshipModel.vendorLogoUrl(relationship);
  return /*#__PURE__*/React.createElement(AgreementViewCard, {
    className: cn(styles.signedHeader, {
      [styles.withLogo]: vendorLogoUrl
    })
  }, /*#__PURE__*/React.createElement(TopStripe, {
    backgroundColor: brandColor
  }), vendorLogoUrl && /*#__PURE__*/React.createElement(Logo, {
    logoUrl: vendorLogoUrl
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.datesContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Agreement between")), /*#__PURE__*/React.createElement("div", {
    className: styles.contactDetailsContainer
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DetailsText, {
    "data-testid": testPrefix + 'seller-name'
  }, relationshipModel.sellerFullName(relationship)), /*#__PURE__*/React.createElement(DetailsText, {
    "data-testid": testPrefix + 'vendor-name'
  }, relationshipModel.vendorName(relationship)), /*#__PURE__*/React.createElement(DetailsText, {
    "data-testid": testPrefix + 'seller-email'
  }, relationshipModel.sellerEmail(relationship))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DetailsText, {
    "data-testid": testPrefix + 'buyer-`name'
  }, relationshipModel.buyerFullName(relationship)), /*#__PURE__*/React.createElement(DetailsText, {
    "data-testid": testPrefix + 'customer-name'
  }, relationshipModel.customerName(relationship)), /*#__PURE__*/React.createElement(DetailsText, {
    "data-testid": testPrefix + 'buyer-email'
  }, relationshipModel.buyerEmail(relationship)))), relationshipModel.isApproved(relationship) && relationship.approvalRecord ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2",
    skin: "secondary",
    "data-testid": "digital-signature-block-when"
  }, "This agreement was digitally signed by:", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)), getSortedFormattedDigitalSignatures(relationship.approvalRecord, compact(relationship.additionalApprovalRecords)).map(formattedDigitalSignature => /*#__PURE__*/React.createElement(DigitalSignature, {
    formattedDigitalSignature: formattedDigitalSignature,
    key: formattedDigitalSignature.on + formattedDigitalSignature.ip
  }))) : /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2",
    skin: "secondary",
    "data-testid": "externally-signed-indicator"
  }, "Existing agreement was uploaded and authorized for billing on Anchor by", ' ', relationshipModel.sellerFullName(relationship), " on", ' ', timeModel.formatDateWithTime(relationship.createdOn)));
}